// extracted by mini-css-extract-plugin
export default {"countdown":"lfa-z","srOnly":"mfa-z"};